import { ROUTERS, RoutesNameEnum } from '@/constant';
import { insertObjectIfElse } from '@/utils';

export type ValueType = {
	value: string;
	label: RoutesNameEnum;
};

export const getHeaderOptions = (
	isSystem: boolean,
	isWorker: boolean
): ValueType[] => [
	insertObjectIfElse(
		isSystem,
		{
			value: ROUTERS.UM1_01,
			label: RoutesNameEnum.SYSTEM,
		},
		insertObjectIfElse(
			isWorker,
			{
				value: ROUTERS.ED1_01,
				label: RoutesNameEnum.WORKER,
			},
			{
				value: ROUTERS.OD1_01,
				label: RoutesNameEnum.FOREIGN,
			}
		)
	) as ValueType,
];

export const hideTabHeaderList = [ROUTERS.MP1_01];

export const screenHasAllProgramList = [
	ROUTERS.ED1_01,
	ROUTERS.AR1_01,
	ROUTERS.FR1_01,
	ROUTERS.PM1_01,
	ROUTERS.AM1_01,
];

export type THeaderMobile = {
	title: string;
	handleCustomBack?: () => void;
};
